// @flow

import React from 'react'

export type PropTypes = {
  rates: Array<{
    eventTypeText: string,
    rate: number,
  }>,
}

function getGraphStyle(per: number) {
  return {
    width: `${per}%`,
  }
}

export default (props: Object) => (
  <section className="space-main__section clearfix space-main__usage">
    <h2 className="space-main__headline">
      {i18n.t('page.room.usageGraphTitle')}
    </h2>
    <ul>
      {props.rates.map((data, i) => (
        <li key={`usage_rate_${i}`} className="space-main__usage-list">
          <p className="space-main__usage-name">{data.eventTypeText}</p>
          <p className="space-main__usage-graph">
            <span
              className="space-main__usage-graph-content"
              style={getGraphStyle(data.rate)}
            />
          </p>
          <p className="space-main__usage-per">{`${data.rate}％`}</p>
        </li>
      ))}
    </ul>
  </section>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailUsageSection/index.jsx